import { DiagnosisRegistrationStoreData } from '@/pages/demands/contexts/diagnosis-registration-store'
import { defaultCalendarDiagnosis } from '@/pages/demands/steps/register'

export interface MappingDiagnosisMapperProps {
  registerData: DiagnosisRegistrationStoreData['registerData']
}

export class MappingDiagnosisMapper {
  private registerData

  constructor(props: MappingDiagnosisMapperProps) {
    this.registerData = props.registerData
  }

  build() {
    const mapping = this.registerData?.calendar_diagnosis
    if (mapping?.id !== defaultCalendarDiagnosis.id) {
      return mapping?.id!
    }
    return null
  }
}
